import React, { useState } from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../components/ToastMsg";
import { publicKeyEncryption } from "../../../redux/features/webx/webxService";
import { setShouldRefreshWallet } from "../../../redux/features/wallet/walletSlice";

const WebxpayDepositWallet = ({ walletId, totalAmount, onValidationError }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.userDetails.details);
  const key = useSelector((state) => state.webx.encryption.encryptedCode);

  const [loading, setLoading] = useState(false);

  const custom_fields = btoa('wallet');

  const checkoutOrder = async (event) => {
    event.preventDefault();
    let errors = {};
    if (!totalAmount || totalAmount.trim() === "") {
      errors.amount = "Amount is required";
    } else if (isNaN(totalAmount)) {
      errors.amount = "Amount must be a number";
    } else if (parseFloat(totalAmount) <= 0) {
      errors.amount = "Amount must be greater than 0";
    } else if (parseFloat(totalAmount) < 40) {
      errors.amount = "Minimum deposit is 40";
    }

    if (Object.keys(errors).length > 0) {
      if (onValidationError) {
        onValidationError(errors);
      }
      return;
    }

    if (onValidationError) {
      onValidationError({});
    }
    try {
      setLoading(true);
      const plain_text = {
        plaintext: `${walletId}|${totalAmount}`
      }
      await dispatch(publicKeyEncryption(plain_text)).unwrap();
      const form = document.getElementById("webxPayWalletForm");
      form.submit();
      setLoading(false);
      dispatch(setShouldRefreshWallet(true));
    } catch (error) {
      showToast("error", error.message);
      setLoading(false);
      dispatch(setShouldRefreshWallet(true));
      showToast('error', error)
    }
  };

  return (
    <form
      action="https://webxpay.com/index.php?route=checkout/billing"
      method="POST"
      id="webxPayWalletForm">
      <input type="hidden" name="return_url" value={`http://mylottery.lk`} />
      <input type="hidden" name="first_name" value={user?.full_name} />
      <input type="hidden" name="last_name" value="MyLottery" />
      <input type="hidden" name="email" value={user.email} />
      <input type="hidden" name="contact_number" value={user.phone_number} />
      <input type="hidden" name="address_line_one" value="46/46, Green Lanka Building" />
      <input type="hidden" name="address_line_two" value="Nawam Mawatha" />
      <input type="hidden" name="city" value="Colombo" />
      <input type="hidden" name="state" value="Western" />
      <input type="hidden" name="postal_code" value="10300" />
      <input type="hidden" name="country" value="Sri Lanka" />
      <input type="hidden" name="process_currency" value="LKR" />
      <input type="hidden" name="payment_gateway_id" value="" />
      <input type="hidden" name="multiple_payment_gateway_ids" value="" placeholder="|seperated ids" />
      <input type="hidden" name="cms" value="PHP" />
      <input type="hidden" name="custom_fields" value={custom_fields} />
      <input type="hidden" name="enc_method" value="JCs3J+6oSz4V0LgE0zi/Bg==" />
      <input type="hidden" name="secret_key" value="53a04eba-4edd-429c-b802-d1bdf10d1e82" />
      <input type="hidden" name="payment" value={key} />
      <input
        type="button"
        value={loading ? `Depositing` : t("Deposit")}
        className={`primary-btn ${styles.purchaseBtn}`}
        onClick={checkoutOrder}
        disabled={loading} />
    </form>
  );
};

export default WebxpayDepositWallet;